import React from "react";
import SectionTitle from "../../components/SectionTitle";
import Benefits from "../../components/Benefits";
import { AboutContent, AboutStyled } from "./styles";



function About({about}) {
  return (
    <AboutStyled>
      <SectionTitle text={"About"} />
      <AboutContent>
        {about}
      </AboutContent>
      <Benefits />
    </AboutStyled>
  );
}

export default About;
